// extracted by mini-css-extract-plugin
export default {"blog-page":"BlogPage_blog-page__-ok8f"};